export const TOOLTIP_ARROW_SIZE = 7;
